// useDocumentTitle — set document.title declaratively from a route component.
//
// Plan ref: 06-02-PLAN §<interfaces> useDocumentTitle (per REVISION 5)
//          + REQ: UI-A11Y-06 (per-route <title>)
//
// Convention (enforced by tests + studio/docs/design/responsive.md):
//   the title MUST follow the format `'Studio · <LaneName>'`.
//
// Behavior:
//   - Sets document.title on mount (and whenever `title` changes).
//   - Restores the prior document.title on unmount, so a modal/lightbox
//     that mounts mid-navigation doesn't leak its title back to the lane.

import { useEffect } from 'react';

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
